import { IFrequencyCap } from '../../entities/frequency-caps';
import { useQueries } from 'react-query';
import { IResponse } from 'utils/queryResponse';
import { getFrequencyCapsList } from '../../queries/queries';

export const useFrequencyCaps = (siteId: string): IResponse<IFrequencyCap[]> => {
  const queries = [{ queryKey: ['frequencyCapsList', siteId], queryFn: () => getFrequencyCapsList(siteId) }];

  const results = useQueries(queries);
  const isError = results.some(result => result.isError);
  const isLoading = results.some(result => result.isLoading);
  const isSuccess = results.every(result => result.isSuccess);
  const data = (results[0]?.data ?? []) as IFrequencyCap[];
  const hasData = !!data.length;

  return {
    data: data,
    isError,
    isLoading,
    isSuccess,
    hasData,
  };
};
